<div>
  <h1>{{'RESULTS.SECTIONS.BASELINE_FINANCIAL_METRICS' | anessaTranslation: trigger}}</h1>
  <!--SET AS DEFAULT BUTTON-->
  <div>
    <app-result-set-config-btn *ngIf="resultConf"
                               [resultSetConfig]="resultConf"
                               (toggleChangeNotifier)="onResultSetDefaultChange()"
    >
    </app-result-set-config-btn>
  </div>
  <!--END SET AS DEFAULT BUTTON-->
  <!--START SELECTION BOXES-->
  <div class="row fl">
    <!-- Result Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-financial-metrics-result_select"
          multiple
          disableOptionCentering
          [placeholder]="'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger"
          [value]="selectedResults"
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <div class="dropdown-select-all-container">
            <mat-checkbox
              class="mat-option mat-option-multi"
              color="primary"
              (change)="inputsCheckAll($event); setResultSetConfDisabled()"
              [checked]="allInputsSelected()"
              [indeterminate]="isCheckAllIndeterminate()"
              #inputsCheckbox>
              {{ inputsCheckbox.checked ? ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: trigger) :
              ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: trigger)}}
              </mat-checkbox>
          </div>
          <ng-container *ngFor="let result of resultOptions">
            <mat-option
              [value]="result"
              (click)="optClick(result)">
              {{ result | anessaTranslation: trigger }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Currency Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-financial-metrics-currency_select"
          [(value)]="selectedCurrency"
          [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
          disableOptionCentering
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <mat-option disabled>
            {{'RESULTS.GENERAL.RATES_FROM' | anessaTranslation: trigger}}: {{ exchangeRateDate }}
          </mat-option>
          <mat-option
            *ngFor="let unit of currencyData"
            [value]="unit">{{ unit.translationId | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!--END SELECTION BOXES-->
  <div class="fl" *ngIf="isShowResults()">
    <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
  </div>

  <!-- START TABLE -->
  <div *ngIf="isShowResults() && tableHeaders">
    <results-treetable
      [resultsData]="tableData"
    ></results-treetable>
  </div>
  <!-- END TABLE -->
</div>
